import { useState, useEffect } from 'react';
import './index.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Practitioners from './pages/Practitioners';
import Patients from './pages/Patients';
import About from './pages/About';
import Contact from './pages/Contact';
import { CLINIC_NAME, CLINIC_TAGLINE } from './constants';

export default function App() {
  const [page, setPage] = useState('home');

  useEffect(() => {
    document.title = `${CLINIC_NAME} | ${CLINIC_TAGLINE}`;
  }, []);

  const renderPage = () => {
    switch (page) {
      case 'home':            return <Home onNav={setPage} />;
      case 'practitioners':   return <Practitioners onNav={setPage} />;
      case 'patients':        return <Patients onNav={setPage} />;
      case 'about':           return <About onNav={setPage} />;
      case 'contact':         return <Contact />;
      default:                return <Home onNav={setPage} />;
    }
  };

  return (
    <div>
      <Navbar active={page} onNav={setPage} />
      <main>{renderPage()}</main>
      <Footer onNav={setPage} />
    </div>
  );
}
